import { NavTabs } from "@ternary/ui"
import { Link } from "react-router-dom"

const TABS = [
  ["products", "Products", "/dashboard/products"],
  ["coupons", "Coupons", "/dashboard/coupons"],
  ["rewards", "Rewards", "/dashboard/rewards"],
] as const

/** The tabs between the Commerce pages. */
export function CommerceTabs({ active }: { active: (typeof TABS)[number][0] }) {
  return (
    <NavTabs label="Commerce">
      {TABS.map(([tab, label, path]) => (
        <Link aria-current={tab === active ? "page" : undefined} key={tab} to={path}>
          {label}
        </Link>
      ))}
    </NavTabs>
  )
}

/**
 * The link to Connections → Payment gateways, for the Coupons and Rewards headers: a secondary
 * button that says where it goes, since a bare gear read as the sidebar's Settings.
 */
export function PaymentSettingsLink() {
  return (
    <Link className="tny-button tny-button-secondary" to="/dashboard/stripe">
      Stripe settings
    </Link>
  )
}
